import { Component, Input } from '@angular/core';
import { ChallengeDefinitionEntity } from '../../../../meta-data/app-meta-data.service';

@Component({ selector: 'app-season-banner', template: `
  <header class="season-banner">
    <div class="season-banner-inner">
      <div class="banner-copy"><p class="eyebrow">{{ label }}</p><h1>{{ heading }}</h1></div>
      <div *ngIf="challenge" class="banner-season">
        <p class="season-name">{{ challenge.Name }}</p>
        <p *ngIf="challenge.ChallengeStartDate && challenge.ChallengeEndDate">{{ challenge.ChallengeStartDate | date:'MMM d' }} – {{ challenge.ChallengeEndDate | date:'MMM d, yyyy' }}</p>
      </div>
    </div>
  </header>`, styles: [`
    :host { display:block; }
    .season-banner { background:var(--dw-navbar-bg, #123e30); color:var(--dw-top-menu-color, #fff); padding:40px 28px; font-family:var(--active-body-font, Arial, sans-serif); }
    .season-banner-inner { max-width:1104px; margin:auto; display:flex; justify-content:space-between; align-items:center; gap:32px; }
    .banner-copy { flex:1; min-width:0; }
    .eyebrow { font-size:12px; text-transform:uppercase; letter-spacing:.1em; font-weight:700; opacity:.8; margin:0 0 12px; }
    h1 { font-size:clamp(28px, 3.5vw, 42px); font-weight:800; line-height:1.15; letter-spacing:-.025em; margin:0; max-width:740px; }
    .banner-season { text-align:right; flex:0 1 280px; min-width:180px; }
    .banner-season p { margin:6px 0 0; font-size:14px; line-height:1.5; }
    .banner-season .season-name { font-size:18px; font-weight:700; margin:0; }
    @media(max-width:650px) {
      .season-banner { padding:32px 20px; }
      .season-banner-inner { align-items:flex-start; flex-direction:column; gap:20px; }
      .banner-season { flex:auto; min-width:0; text-align:left; }
    }
  `] })
export class SeasonBannerComponent {
  @Input() label = '';
  @Input() heading = '';
  @Input() challenge: ChallengeDefinitionEntity;
}
